export default __webpack_public_path__ + "static/media/Screen.18fd2e47.png";